<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <params-title />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <params-string-value
          key="1"
          model="'str_value_1'"
        />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <params-number-value1 />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <params-string-value2 />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <params-number-value2 />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <params-string-value3 />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <params-number-value3 />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <params-group />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <params-sub-group />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <param-project />
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
import ParamsTitle from '@/views/Params/Elements/Title.vue'
import ParamsStringValue from '@/views/Params/Elements/StringValue_1.vue'
import ParamsStringValue2 from '@/views/Params/Elements/StringValue_2.vue'
import ParamsStringValue3 from '@/views/Params/Elements/StringValue_3.vue'
import ParamsNumberValue1 from '@/views/Params/Elements/NumberValue_1.vue'
import ParamsNumberValue2 from '@/views/Params/Elements/NumberValue_2.vue'
import ParamsNumberValue3 from '@/views/Params/Elements/NumberValue_3.vue'
import ParamsGroup from '@/views/Params/Elements/ParamGroups.vue'
import ParamsSubGroup from '@/views/Params/Elements/ParamSubGroups.vue'
import ParamProject from '@/views/Params/Elements/ParamProjects.vue'

export default {
  name: 'ParamsItemForm',
  components: {
    ParamProject,
    ParamsSubGroup,
    ParamsGroup,
    ParamsNumberValue3,
    ParamsNumberValue2,
    ParamsNumberValue1,
    ParamsStringValue3,
    ParamsStringValue2,
    ParamsStringValue,
    ParamsTitle,
    BRow,
    BCol,
    BCard,
  },
}
</script>
